import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputTextSF from '../../../widgets/form/InputTextSF'

const NachReportRegisteredAmountUpdateModalUI = ({
  context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick,
  registeredAmount, onRegisteredAmountChange, registeredAmountError, setRegisteredAmountError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Change RegisteredAmount'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputTextSF registeredAmount='select' name='registeredAmount' label='Registered Amount'
      value={registeredAmount} onChange={onRegisteredAmountChange} 
      error={registeredAmountError} setError={setRegisteredAmountError}
    />
  </ModalFormUI>

export default NachReportRegisteredAmountUpdateModalUI
